export const initialAmenities = {
    valet: {
        count: 0,
        slug: 'valet',
        name: 'Valet'
    },
    'self-park': {
        count: 0,
        slug: 'self-park',
        name: 'Self Park'
    },
    'covered-parking': {
        count: 0,
        slug: 'covered-parking',
        name: 'Covered Parking'
    },
    mobile: {
        count: 0,
        slug: 'mobile',
        name: 'Mobile Pass Accepted'
    },
    'in-out': {
        count: 0,
        slug: 'in-out',
        name: 'In and Out Allowed'
    }
};

export const initialReservationTypes = {
    all: {
        slug: 'all',
        name: 'All Availability'
    },
    '247': { // eslint-disable-line quote-props
        slug: '247',
        name: '24/7 Regular Parking',
        description: 'Unlimited parking 7 days a week, 24 hours a day.',
        count: 0,
        related: [],
        active: false
    },
    daytime_only: { // eslint-disable-line camelcase
        slug: 'daytime_only',
        name: 'Daytime Only Parking',
        description: 'Great option if you drive to work but don’t need to park overnight.',
        count: 0,
        related: ['daytime_and_247_weekend', '247'],
        active: false
    },
    daytime_and_247_weekend: { // eslint-disable-line camelcase
        slug: 'daytime_and_247_weekend',
        name: 'Daytime + 24/7 Weekend Parking',
        description: 'Great option if you drive to work during the week and need unlimited parking during the weekend.',
        count: 0,
        related: ['247'],
        active: false
    },
    nights_only: { // eslint-disable-line camelcase
        slug: 'nights_only',
        name: 'Nights Only Parking',
        description: 'Great  option if you need to park overnight, but use your car during the day.',
        count: 0,
        related: ['nights_and_247_weekend', '247'],
        active: false
    },
    nights_and_247_weekend: { // eslint-disable-line camelcase
        slug: 'nights_and_247_weekend',
        name: 'Nights + 24/7 Weekend Parking',
        description: 'Great option if you need to park overnight and throughout the weekend.',
        count: 0,
        related: ['247'],
        active: false
    },
    storage: {
        slug: 'storage',
        name: 'Storage',
        description: 'Safe and secure storage if you want to drop off your car for an extended period of time',
        count: 0,
        related: [],
        active: false
    },
    valet: {
        slug: 'valet',
        name: 'On-Demand Valet',
        description: 'Book through SpotHero and and a third party valet will pick up/drop off your car at your desired location. Restrictions apply.',
        count: 0,
        related: [],
        active: false
    }
};
